// @flow
import * as React from 'react';
import Slider from 'react-toolbox/lib/slider';

import theme from './ZoomLevelChanger.scss';

type Props = {
    zoomLevel: number,
    showZoomLevelChanger: boolean,
    onZoomLevelChanged: (newZoomLevel: number) => void
};

export const ZoomLevelChanger = ({
    zoomLevel,
    onZoomLevelChanged,
    showZoomLevelChanger = true
}: Props) => {
    if (!showZoomLevelChanger) {
        return null;
    }
    return (
        <div className={theme.zoomSliderWrap}>
            <Slider
                snaps
                min={1}
                max={9}
                step={1}
                editable
                value={zoomLevel}
                theme={theme}
                onChange={onZoomLevelChanged}
            />
        </div>
    );
};

export default ZoomLevelChanger;
